import React from "react";
import {TrendingUp} from "@mui/icons-material";
import {ANALYTICS_MONTHLY} from "./constants";
import {Autocomplete} from "@mui/material";
import TextField from "@mui/material/TextField";


export const ChooseAProduct = ({formState, setFormState, setUserOverride}) => {
    const showTotal = () => {
        const options = [];
        for (let i = 1; i <= 99; i++) {
            options.push({value: i, label: i + " Store" + (i > 1 ? "s" : "")});
        }
        const selectedOption = options.find(option => option.value === formState.store_count) || {value: 0, label: "---"};
        const savings = `You SAVE ${(formState.store_count * 29.99).toFixed(2)} on your first month with promo code CANOLD1025. Just ${(formState.store_count * 29.99).toFixed(2)}/month (+tax) after that.`

        return <>
            <Autocomplete
                className={"create-account-choose-nStores"}
                filterSelectedOptions
                disabled={false}
                value={selectedOption}
                id={"choose-nStores"}
                name={"choose-nStores-dropdown"}
                role={"choose-nStores-dropdown"}
                options={options}
                disablePortal={true}
                isOptionEqualToValue={(option, value) => {
                    return option.value === value.value;
                }}
                onChange={(evt, option) => {
                    setUserOverride(true);
                    setFormState({...formState, store_count: option?.value || 0})
                }}
                renderOption={(props, option) => {
                    return <li {...props} key={"choose-nStores-" + option.value}>
                        {option.label}
                    </li>
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label=""
                        placeholder="---"
                        role={"choose-nStores-dropdown-input"}
                        key={"choose-nStores-dropdown-input"}
                    />
                )}
            />
            {formState.store_count && formState.store_count > 0 && savings || ""}
        </>
    }

    return <div className={"create-account-choose-a-product-container"}>
        <div className={"create-account-choose-product choose-analytics-monthly"}>
            <div className={"create-account-choose-product-icon-container"}>
                <TrendingUp
                    className={"create-account-choose-product-icon" + (formState.product === ANALYTICS_MONTHLY ? " selected" : "")}
                    onClick={() => {
                        setFormState({
                            ...formState,
                            product: ANALYTICS_MONTHLY
                        });
                    }}
                />
            </div>
            <h3>How Many Stores Do You Operate?</h3>
            <h4>{showTotal()}</h4>
            <p className={"promo-container"}><span className={"promo"}>Risk Free Guarantee</span>: If we don&apos;t pay for ourselves in ROI each month, then that month is <span className={"promo"}>free.</span></p>
        </div>
    </div>;
};


export default ChooseAProduct;
